export default __webpack_public_path__ + "static/media/iPhoneWithImage.2129aa49.png";